import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
    Box,
    Breadcrumbs,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    Divider,
    Grid,
    Menu,
    MenuItem,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useTheme,
} from '@mui/material';
import React, { Suspense, useState, Fragment } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import "./send.css";
import DownloadIcon from '@mui/icons-material/Download';
// import CheckCircleOutlined from "@mui/icons-material/CheckCircle";
import { Close, Delete, Edit, Receipt } from '@mui/icons-material';
import { useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { ESTIMATE_INVOICE_TABLE_ROW } from '../../../App';
import CommonDialog from '../../../common/CommonDialog';
import FormatNumber, { FormatTotalNumbers } from '../../../components/FormatNumber/FormatNumber';
import { SHOP_CREATED } from '../../../config/dataService/constants';
import { DETAIL_STATUS, DetailStatusChip } from '../../../common/DetailStatusChip';
import { deleteFinalizedEstimate, sendEstimate } from '../../../redux/Estimate/action';
import { estimateQueryKeys } from '../../../services/business/estimates/estimates.hooks';
import { useGetShopConfig, useGetShopTaxes } from '../../../services/core/settings';
import {
    ESTIMATE_STATUS,
    INVENTORY_MANAGE_TYPE,
    INVENTORY_TYPES,
    MILEAGE_UNIT,
    normalizeWorkOrderStatus,
    PART_TYPES,
    PRICING_TYPES,
    WORK_ORDER_STATUS,
} from '../../../utility/Constant';
import LinkedDocumentLink, {
    estimateInvoices,
    firstLinked,
    estimateWorkOrderToSync,
    getEstimateListCrumb,
    getWorkOrderSyncFromEstimateUrl,
    SYNC_PROMPT_TEXT,
} from '../../../common/LinkedDocumentLink';
import SyncUpdateIcon from '../../../utility/Svg/SyncUpdateIcon';
import CreateWorkOrderSvg from '../../../utility/Svg/CreateWorkOrderSvg';
import PartBrandSvg from '../../../utility/Svg/PartBrandSvg';
import PartCategorySvg from '../../../utility/Svg/PartCategorySvg';
import AddInventoryModal from '../../Inventory/AddInventory';
import { CustomTooltip } from '../../../utility/helpers/commonFunction';
import { NumericEngine } from '../../../utility/helpers/numericEngine';
import { shouldShowPerServiceSubtotalRow } from '../../../utility/helpers/shouldShowPerServiceSubtotalRow';
import InfoIconSvg from '../../../utility/Svg/InfoIconSvg';
import LinkIcon from '../../../utility/Svg/LinkIcon';
import SaveAndSendSvg from '../../../utility/Svg/SaveAndSendSvg';
import SuccessMessageModal from '../../Common/SuccessMessage';
import UpdateCustomerModal from '../../Customers/Profile/UpdateCustomerModal';
import EstimateFeesTable from '../EstimateCommonComponents/EstimateFeesTable';
import EstimatePaymentDetails from '../EstimateCommonComponents/EstimatePaymentDetails';
import EstimateTermsAndWarranty from '../EstimateCommonComponents/EstimateTermsAndWarranty';
import DetailPageHeaderInfoColumns from '../../Invoice/invoiceCommonComponents/DetailPageHeaderInfoColumns';
import InvoiceRecommandationSection from '../../Invoice/invoiceCommonComponents/InvoiceRecommandationSection';
import AddCustomerModalV4 from '../../../common/AddCustomerModalV4';
import LineTaxCell from '../../../common/Tax/LineTaxCell';
import { DOCUMENT_TAX_TYPE, isNewTaxVersion, LINE_TAX_KIND, recordHasPartsOrPackages, recordPartGrossAmount } from '../../../utility/helpers/taxCalculation';
import { useProvinceTaxGroup } from '../../../utility/hooks/useProvinceTaxGroup';

const EstimateFinalized = ({ estimateId, estimateData, customerData, setCustomerData, showLoader, setShowLoader, fetchApi }) => {
    const provinceTaxGroup = useProvinceTaxGroup();
    const documentHasPartsOrPackages = recordHasPartsOrPackages(estimateData);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const theme = useTheme();

    const [openSuccessModal, setOpenSuccessModal] = React.useState(false);
    const [selectedInventoryId, setSelectedInventoryId] = useState(null);
    // { message, onContinue } while an "Invoice Already Exists" warning is showing.
    const [batchNumber, setBatchNumber] = useState(null);
    const [openPartModel, setOpenpartModel] = useState(false);
    const [openBatchSelectionModal, setBatchSelectionModal] = useState(false);
    const [inventoryOption, setInventoryOption] = useState(null);
    const [successMessage, setSuccessMessage] = React.useState('');

    const [isDeleteModal, setIsDeleteModal] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false);

    const [openEditCustomer, setOpenEditCustomer] = useState(false);
    const [primaryEmailIndex, setPrimaryEmailIndex] = useState(0);
    const [addressValues, setAddressValue] = useState({
        street_number: '',
        city: '',
        province: '',
        postal: '',
        country: '',
        provinceId: '',
        cityId: '',
    });

    const { data: shopConfigData, isLoading: isConfigLoading, error: configError } = useGetShopConfig();
    const { data: shopTaxesData } = useGetShopTaxes();

    const showLineTax = isNewTaxVersion(estimateData);

    const mileageUnit = shopConfigData?.config?.mileageUnit === MILEAGE_UNIT.MILES ? MILEAGE_UNIT.MILES : MILEAGE_UNIT.KM;

    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open1 = Boolean(anchorEl);
    const handleClick1 = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose1 = () => {
        setAnchorEl(null);
    };

    const handlePreviewPdf = () => {
        const pdfUrl = estimateData?.pdfUrl;
        window.open(pdfUrl, '_blank');
    };

    const handleSend = async () => {
        try {
            setShowLoader(true);
            const data = await dispatch(sendEstimate(estimateId));
            if (data) {
                setOpenSuccessModal(true);

                setSuccessMessage('Estimate was successfully emailed to customer');

                handleClose1();
                setTimeout(() => {
                    fetchApi();
                    navigate(`/estimates/sent/${estimateId}`);
                }, 1500);
            }
        } catch (error) {
            setShowLoader(false);
        } finally {
        }
    };

    // Only invoices made directly from this estimate — an invoice that came through its work order
    /*
     * Which options this estimate offers (spec §6.4):
     *   scenario 1 — nothing linked            → Create Work Order + Convert to Invoice
     *   scenario 2/3 — any linked invoice, draft or not → View / Update to Invoice, no work order
     */
    const estimateOwnInvoices = estimateInvoices(estimateData);
    /** The estimate's own invoice — the one it can update (scenario 4). */
    const ownInvoice = estimateOwnInvoices[0] || null;
    const linkedWorkOrder = firstLinked(estimateData?.linkedWorkOrderId);
    const hasLinkedWorkOrder = Boolean(linkedWorkOrder?._id);
    /**
     * Scenario 7 — Estimate ⇒ Work Order ⇒ Invoice: the invoice hangs off the work order, and the
     * estimate links to both. That invoice is view-only here; it is updated from the work order
     * (scenario 8).
     */
    const workOrderInvoice = firstLinked(linkedWorkOrder?.linkedInvoiceId);
    const linkedInvoice = ownInvoice || workOrderInvoice || null;
    const hasLinkedInvoice = Boolean(linkedInvoice?._id);
    const isLinkedInvoiceOutOfDate = Boolean(ownInvoice) && ownInvoice?.isSyncedWithEstimate === false;
    // Scenario 5 — with a work order in between, the invoice is created from the work order, so the
    // estimate does not offer Convert to Invoice.
    const canConvertToInvoice = !hasLinkedInvoice && !hasLinkedWorkOrder;
    // Any linked invoice blocks a new work order; blocked hides the option (there is none to view).
    const canCreateWorkOrder = !hasLinkedWorkOrder && !hasLinkedInvoice;

    const getLinkedInvoiceUrl = () => {
        const row = linkedInvoice;
        if (!row?._id) return '#';
        let status;

        if (row?.status === 'draft') {
            status = 'draft';
        } else if (row?.status === 'sent') {
            status = row.isEmailSent ? 'sent' : 'finalized';
        } else {
            status = row.status;
        }

        return `/invoice/${status}/${row?._id}`;
    };

    /** Work order detail url by status — mirrors getLinkedInvoiceUrl above. */
    /** Estimate ⇒ Work order sync (spec §6.5): the linked work order when it has fallen behind this estimate. */
    const workOrderToSync = estimateWorkOrderToSync(estimateData);
    /** Breadcrumb back to the list this estimate is in — Invoiced and Work Order have their own tabs. */
    const listCrumb = getEstimateListCrumb(estimateData);
    const handleUpdateToWorkOrder = () => {
        if (!workOrderToSync?._id) return;
        navigate(getWorkOrderSyncFromEstimateUrl(workOrderToSync._id), { state: { estimateData } });
    };

    const getLinkedWorkOrderUrl = () => {
        const workOrders = estimateData?.linkedWorkOrderId;
        if (!workOrders || workOrders.length === 0) return '#';

        const row = workOrders[0];
        return `/work-orders/${normalizeWorkOrderStatus(row?.status) || WORK_ORDER_STATUS.OPEN}/${row?._id}`;
    };

    const hasCustomerEmail = !!estimateData?.customer?.email;
    const customerId = estimateData?.customer?._id;

    const serviceSubtotalCache = new WeakMap();
    const selectServiceSubtotal = (service) => {
        if (!service) return '0';

        if (serviceSubtotalCache.has(service)) {
            return serviceSubtotalCache.get(service);
        }
        let subtotal = '0';

        // FIXED service pricing
        if (service.pricingType === PRICING_TYPES.FXIED) {
            subtotal = service.fixedPrice || '0';
        }

        // LABOUR & PARTS service pricing
        if (service.pricingType === PRICING_TYPES.LABOUR) {
            const laborAmount = service.labor?.totalAmount || '0';

            // qty × (cost + per-unit fee) — totalAmount is qty × cost only (see recordPartGrossAmount).
            const partsAmount = (service.parts || []).reduce((acc, part) => NumericEngine.add(acc, String(recordPartGrossAmount(part))), '0');

            subtotal = NumericEngine.add(laborAmount, partsAmount);
        }

        serviceSubtotalCache.set(service, subtotal);

        return subtotal;
    };

    return (
        <>
            <Box
                padding={'32px 24px'}
                sx={{
                    bgcolor: 'background.main',
                    width: 'fit-content',
                    minWidth: '100%',
                }}
            >
                {' '}
                {/* position: relative — the links below are pinned to this header's top-right corner, so one
                    link and two take exactly the same room and nothing shifts down. */}
                <Grid container sx={{ padding: '16px 0px', position: 'relative' }} gap={'8px'}>
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div role="presentation" onClick={handleClick}>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    to="/estimates/all"
                                    style={{
                                        color: 'black',
                                        opacity: '0.6',
                                        textDecoration: 'none',
                                    }}
                                >
                                    Estimates
                                </Link>
                                <Link
                                    to={listCrumb.to}
                                    style={{
                                        color: 'black',
                                        opacity: '0.6',
                                        textDecoration: 'none',
                                    }}
                                >
                                    {listCrumb.label}
                                </Link>
                                <Link to="/estimates/all" style={{ color: 'black', textDecoration: 'none' }}>
                                    {estimateData && estimateData?.estimateNumber}
                                </Link>
                            </Breadcrumbs>
                        </div>
                        {/* Linked documents: the invoice first, the work order beneath it. */}
                        <Stack alignItems="flex-end" spacing={0.5} sx={{ position: 'absolute', top: '16px', right: 0 }}>
                            {/*
                             * Only the estimate's OWN invoice is linked here. With a work order in between
                             * the estimate's changes go to the work order, so its invoice is reached through
                             * View Invoice in More Actions instead (client, 2026-09-24).
                             */}
                            {Boolean(ownInvoice?._id) && (
                                <Stack direction="row" spacing={0.5}>
                                    <Link to={getLinkedInvoiceUrl()} style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <LinkIcon color="#002394" />
                                        <Typography
                                            variant="body1"
                                            component="span"
                                            sx={{
                                                color: '#002394',
                                                fontFamily: 'Roboto',
                                                fontSize: '16px',
                                                fontStyle: 'normal',
                                                fontWeight: 400,
                                                lineHeight: '150%',
                                                letterSpacing: '0.15px',
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },
                                            }}
                                        >
                                            Linked to {linkedInvoice?.invoiceNumber || ''}
                                        </Typography>
                                    </Link>
                                    {isLinkedInvoiceOutOfDate && (
                                        <CustomTooltip
                                            width="245px"
                                            placement="top"
                                            leaveDelay={300}
                                            interactive
                                            title={
                                                <>
                                                    <Typography color={'#212121'} mb={'11px'} align="left">
                                                        Estimate changes have not been updated on the invoice.
                                                    </Typography>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        fullWidth
                                                        sx={{
                                                            height: '28px',
                                                            fontSize: '12px',
                                                            fontWeight: 500,
                                                            letterSpacing: '0.46px',
                                                        }}
                                                        onClick={() => {
                                                            navigate(`/invoice/edit-invoice-from-estimate/${estimateOwnInvoices[0]?._id}`, {
                                                                state: {
                                                                    estimateData: estimateData,
                                                                },
                                                            });
                                                        }}
                                                    >
                                                        Update to invoice
                                                    </Button>
                                                </>
                                            }
                                        >
                                            <Box sx={{ display: 'inline-flex', cursor: 'pointer', alignItems: 'center' }}>
                                                <InfoIconSvg />
                                            </Box>
                                        </CustomTooltip>
                                    )}
                                </Stack>
                            )}

                            {hasLinkedWorkOrder && (
                                <LinkedDocumentLink
                                    to={getLinkedWorkOrderUrl()}
                                    documentNumber={linkedWorkOrder?.workOrderNumber}
                                    // Hover shows "Update to Work Order" only while the work order is behind this estimate (spec §6.5).
                                    syncPrompt={
                                        workOrderToSync
                                            ? {
                                                  message: SYNC_PROMPT_TEXT.ESTIMATE_TO_WORK_ORDER,
                                                  actionLabel: 'UPDATE TO WORK ORDER',
                                                  onAction: handleUpdateToWorkOrder,
                                              }
                                            : undefined
                                    }
                                />
                            )}
                        </Stack>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="h4" fontWeight={500}>
                            {estimateData && estimateData?.estimateNumber}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2} justifyContent="end">
                    <Grid item>
                        <Stack direction={'row'} spacing={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                className="btn-text-size-manage"
                                startIcon={<VisibilityIcon />}
                                size="large"
                                onClick={handlePreviewPdf}
                                style={{
                                    fontWeight: 500,
                                    lineHeight: '24px',
                                    letterSpacing: '0.04px',
                                    fontSize: '14px',
                                    height: '42px',
                                }}
                            >
                                View PDF
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={<SaveAndSendSvg />}
                                size="large"
                                onClick={() => {
                                    if (hasCustomerEmail) {
                                        handleSend();
                                    } else {
                                        setOpenEditCustomer(true);
                                    }
                                }}
                                disabled={estimateData?.isEmailSent}
                                style={{
                                    fontWeight: 500,
                                    lineHeight: '24px',
                                    letterSpacing: '0.04px',
                                    fontSize: '14px',
                                    height: '42px',
                                }}
                            >
                                Email to Customer
                            </Button>

                            <Button
                                variant="contained"
                                color="greyColor"
                                id="demo-positioned-button"
                                aria-controls={open1 ? 'demo-positioned-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open1 ? 'true' : undefined}
                                onClick={handleClick1}
                                size="large"
                                style={{
                                    width: '182px',
                                    fontWeight: 500,
                                    lineHeight: '24px',
                                    letterSpacing: '0.4px',
                                    fontSize: '14px',
                                    height: '42px',
                                    color: '#000000',
                                    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.25)',
                                }}
                            >
                                More actions
                                <ExpandMoreIcon style={{ marginLeft: '8px' }} />
                            </Button>
                            <Menu
                                style={{ top: 3 }}
                                id="demo-positioned-menu"
                                aria-labelledby="demo-positioned-button"
                                anchorEl={anchorEl}
                                open={open1}
                                onClose={handleClose1}
                                sx={{
                                    // MORE ACTIONS menu: the button's width, sitting directly under it.
                                    '& .MuiPaper-root': { width: '182px', minWidth: 'unset!important' },
                                    '& .MuiMenuItem-root': { padding: '6px 12px!important', width: '100%' },
                                }}
                            >
                                <MenuItem
                                    onClick={() => {
                                        navigate(`/estimates/edit/${estimateId}`);
                                    }}
                                >
                                    <Edit style={{ marginRight: '8px' }} /> Edit Estimate
                                </MenuItem>

                                <MenuItem
                                    onClick={() => {
                                        navigate(`/customers/${estimateData?.customer?._id}/${estimateData?.customer?.createdFrom}`);
                                    }}
                                >
                                    <VisibilityIcon style={{ marginRight: '8px' }} />
                                    View Customer
                                </MenuItem>

                                {isLinkedInvoiceOutOfDate ? (
                                    <MenuItem
                                        onClick={() => {
                                            navigate(`/invoice/edit-invoice-from-estimate/${linkedInvoice?._id}`, { state: { estimateData } });
                                        }}
                                    >
                                        <SyncUpdateIcon /> Update To Invoice
                                    </MenuItem>
                                ) : hasLinkedInvoice ? (
                                    <MenuItem
                                        onClick={() => {
                                            navigate(`${getLinkedInvoiceUrl()}`);
                                        }}
                                    >
                                        <Receipt style={{ marginRight: '8px' }} /> View Invoice
                                    </MenuItem>
                                ) : canConvertToInvoice ? (
                                    <MenuItem
                                        onClick={() => {
                                            navigate(`/invoice/new-invoice-from-estimate`, { state: { estimateData } });
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginRight: '8px',
                                                width: '24px',
                                                height: '24px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            {' '}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <g clip-path="url(#clip0_19799_39016)">
                                                    <path
                                                        d="M15 14.1665H5V12.4998H15V14.1665ZM15 10.8332H5V9.1665H15V10.8332ZM15 7.49984H5V5.83317H15V7.49984ZM2.5 18.3332L3.75 17.0832L5 18.3332L6.25 17.0832L7.5 18.3332L8.75 17.0832L10 18.3332L11.25 17.0832L12.5 18.3332L13.75 17.0832L15 18.3332L16.25 17.0832L17.5 18.3332V1.6665L16.25 2.9165L15 1.6665L13.75 2.9165L12.5 1.6665L11.25 2.9165L10 1.6665L8.75 2.9165L7.5 1.6665L6.25 2.9165L5 1.6665L3.75 2.9165L2.5 1.6665V18.3332Z"
                                                        fill="black"
                                                    />
                                                    <path
                                                        d="M15.5 9.5C18.8138 9.5 21.5 12.1862 21.5 15.5C21.5 18.8138 18.8138 21.5 15.5 21.5C12.1862 21.5 9.5 18.8138 9.5 15.5C9.5 12.1862 12.1862 9.5 15.5 9.5ZM15.4502 15.4502H13.25V15.5498H15.4502V17.75H15.5498V15.5498H17.75V15.4502H15.5498V13.25H15.4502V15.4502Z"
                                                        fill="white"
                                                        stroke="white"
                                                    />
                                                    <path
                                                        d="M15.5 11C13.0147 11 11 13.0147 11 15.5C11 17.9853 13.0147 20 15.5 20C17.9853 20 20 17.9853 20 15.5C20 13.0147 17.9853 11 15.5 11ZM17.75 15.95H15.95V17.75H15.05V15.95H13.25V15.05H15.05V13.25H15.95V15.05H17.75V15.95Z"
                                                        fill="black"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_19799_39016">
                                                        <rect width="20" height="20" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                        Convert to Invoice
                                    </MenuItem>
                                ) : null}

                                {/* Estimate ⇒ Work Order — same contract as Convert to Invoice, including the
                                    swap to a view action once the estimate already has a linked work order. */}
                                {/* Linked work order: Update to Work Order while it is behind this estimate, View otherwise (spec §6.5). */}
                                {workOrderToSync ? (
                                    <MenuItem onClick={handleUpdateToWorkOrder}>
                                        <SyncUpdateIcon /> Update Work Order
                                    </MenuItem>
                                ) : hasLinkedWorkOrder ? (
                                    <MenuItem
                                        onClick={() => {
                                            navigate(`${getLinkedWorkOrderUrl()}`);
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginRight: '8px',
                                                width: '24px',
                                                height: '24px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <CreateWorkOrderSvg />
                                        </div>
                                        View Work Order
                                    </MenuItem>
                                ) : canCreateWorkOrder ? (
                                    <MenuItem
                                        onClick={() => {
                                            navigate(`/work-orders/new-from-estimate`, { state: { estimateData } });
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginRight: '8px',
                                                width: '24px',
                                                height: '24px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <CreateWorkOrderSvg />
                                        </div>
                                        Create Work Order
                                    </MenuItem>
                                ) : null}

                                <MenuItem
                                    onClick={() => {
                                        navigate(`/estimates/new`, {
                                            state: {
                                                duplicateEstimateId: estimateId,
                                            },
                                        });
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        style={{ marginRight: '8px' }}
                                    >
                                        <path
                                            d="M3.33464 18.3333H13.3346C13.7767 18.3333 14.2006 18.1577 14.5131 17.8452C14.8257 17.5326 15.0013 17.1087 15.0013 16.6667V6.66667C15.0013 6.22464 14.8257 5.80072 14.5131 5.48816C14.2006 5.17559 13.7767 5 13.3346 5H3.33464C2.89261 5 2.46868 5.17559 2.15612 5.48816C1.84356 5.80072 1.66797 6.22464 1.66797 6.66667V16.6667C1.66797 17.1087 1.84356 17.5326 2.15612 17.8452C2.46868 18.1577 2.89261 18.3333 3.33464 18.3333ZM5.0013 10.8333H7.5013V8.33333H9.16797V10.8333H11.668V12.5H9.16797V15H7.5013V12.5H5.0013V10.8333Z"
                                            fill="black"
                                        />
                                        <path
                                            d="M16.668 1.66675H6.66797V3.33341H16.668V13.3334H18.3346V3.33341C18.3346 2.41425 17.5871 1.66675 16.668 1.66675Z"
                                            fill="black"
                                        />
                                    </svg>
                                    Duplicate Estimate
                                </MenuItem>

                                <MenuItem
                                    onClick={() => {
                                        setIsDeleteModal(true);
                                        handleClose1();
                                    }}
                                    style={{ color: '#D32F2F!important' }}
                                >
                                    <Delete style={{ marginRight: '8px', color: '#D32F2F' }} /> <span style={{ color: '#D32F2F' }}> Delete Estimate </span>
                                </MenuItem>
                            </Menu>
                        </Stack>
                    </Grid>
                </Grid>
                <Grid container padding={'32px'} margin={'32px 0'} boxShadow={2} gap={2} bgcolor={'white'}>
                    <Grid container item spacing={2} justifyContent="space-between" paddingRight={0}>
                        <Grid item lg={7} md={12} sm={12} xs={12}>
                            <Typography variant="h3" fontWeight={400}>
                                Estimate{' '}
                            </Typography>
                            <Stack direction="row" justifyContent={'flex-start'} gap={2} mt={1} sx={{ flexWrap: 'wrap' }}>
                                {/*
                                 * Chips follow the estimate's own status (client); WO Created and Invoiced open
                                 * the linked document:
                                 *   work order → Finalized + WO Created
                                 *   invoiced through a work order → WO Created + Invoiced
                                 *   invoiced directly              → Finalized + Invoiced
                                 */}
                                {estimateData?.status === ESTIMATE_STATUS.INVOICED ? (
                                    <>
                                        {hasLinkedWorkOrder ? (
                                            <DetailStatusChip status={DETAIL_STATUS.WORK_ORDER} to={getLinkedWorkOrderUrl()} />
                                        ) : (
                                            <DetailStatusChip status={DETAIL_STATUS.FINALIZED} />
                                        )}
                                        <DetailStatusChip status={DETAIL_STATUS.INVOICED} to={hasLinkedInvoice ? getLinkedInvoiceUrl() : undefined} />
                                    </>
                                ) : estimateData?.status === ESTIMATE_STATUS.WORK_ORDER ? (
                                    <>
                                        <DetailStatusChip status={DETAIL_STATUS.FINALIZED} />
                                        <DetailStatusChip status={DETAIL_STATUS.WORK_ORDER} to={hasLinkedWorkOrder ? getLinkedWorkOrderUrl() : undefined} />
                                    </>
                                ) : (
                                    <DetailStatusChip status={DETAIL_STATUS.FINALIZED} />
                                )}
                            </Stack>
                        </Grid>
                        <Grid item>
                            <Stack spacing={0}>
                                <Typography variant="body1" fontWeight={500} fontSize={'24px'} align="right">
                                    {estimateData && estimateData?.estimateNumber}
                                </Typography>
                                <Typography variant="body1" fontWeight={400} sx={{ marginTop: '8px' }}>
                                    {estimateData && (estimateData?.serviceAdvisor || estimateData?.estimateCreatedBy)
                                        ? ` Service Advisor: ${estimateData?.serviceAdvisor?.name || estimateData?.estimateCreatedBy}`
                                        : ''}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                    <Divider style={{ width: '100%', marginTop: '8px' }} />
                    {/* <Grid container item paddingRight={2}>
                        <Grid item>
                            <Stack>
                                <Typography variant="h6">{estimateData && estimateData?.shop?.shopName}</Typography>
                                <Typography variant="body1" fontWeight={400}>
                                    {estimateData &&
                                        estimateData?.shop?.address +
                                            ', ' +
                                            estimateData?.shop?.city?.city +
                                            ', ' +
                                            estimateData?.shop?.province?.province +
                                            ', ' +
                                            estimateData?.shop?.postalCode}
                                </Typography>
                                <Typography variant="body1" fontWeight={400}>
                                    {formatPhoneNumber(estimateData?.shop?.phoneNumber)}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid> */}
                    <Grid container item justifyItems={'space-between'} paddingRight={0} style={{ marginTop: '8px' }}>
                        <DetailPageHeaderInfoColumns
                            documentType="estimate"
                            estimateDate={estimateData?.estimateDate}
                            customer={estimateData?.customer}
                            customerPO={estimateData?.customerPO}
                            vehicle={estimateData?.vehicle}
                            mileageUnit={mileageUnit}
                            estimateMileageOnly={estimateData?.odoDroppedOff == null && estimateData?.odoReturned == null}
                            odoDroppedOff={estimateData?.odoDroppedOff}
                            odoReturned={estimateData?.odoReturned}
                            mileageInDate={estimateData?.estimationExpiryDate}
                            mileageOutDate={estimateData?.completionDate}
                            estimateSingleOdo={estimateData?.odo}
                            estimateSingleOdoDate={estimateData?.completionDate || estimateData?.estimateDate}
                        />
                        {estimateData?.note && (
                            <Grid item xs={12} mt={2}>
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.87)',
                                        fontSize: '16px',
                                        fontWeight: 500,
                                        lineHeight: '150%',
                                        letterSpacing: '0.15px',
                                    }}
                                >
                                    Internal Shop Memo
                                </Typography>
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.65)',
                                        marginTop: '8px',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        lineHeight: '24px',
                                        letterSpacing: '0.15px',
                                    }}
                                >
                                    {estimateData?.note}
                                </Typography>
                            </Grid>
                        )}

                        {estimateData &&
                            estimateData?.services.map((item, index) => {
                                const serviceSubtotal = selectServiceSubtotal(item) ?? '0';

                                return (
                                    <>
                                        <Grid
                                            container
                                            item
                                            sx={{
                                                mt: '32px',
                                            }}
                                        >
                                            <Grid item xs={12}>
                                                <Typography
                                                    sx={{
                                                        px: '16px',
                                                        py: '12px',
                                                        bgcolor: 'secondary.main',
                                                        color: '#FFFFFF',
                                                        borderTopLeftRadius: '4px',
                                                        borderTopRightRadius: '4px',

                                                        fontSize: '20px',
                                                        fontWeight: 500,
                                                        lineHeight: '32px',
                                                        letterSpacing: '0.15px',
                                                    }}
                                                >
                                                    {item?.serviceName}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        {item?.pricingType == 'labor_&_parts' ? (
                                            <Grid container item>
                                                <Grid item xs={12}>
                                                    <TableContainer sx={{ maxHeight: 600 }}>
                                                        <Table
                                                            aria-label="estimate service table"
                                                            padding="16px"
                                                            sx={{
                                                                width: '100%',
                                                                tableLayout: 'fixed',

                                                                '& .MuiTableCell-root': {
                                                                    borderBottom: '1px solid rgba(0,0,0,0.12)',
                                                                    verticalAlign: 'middle',
                                                                    color: '#212121',
                                                                },
                                                            }}
                                                        >
                                                            <colgroup>
                                                                <col style={{ width: 56 }} />
                                                                <col />
                                                                <col style={{ width: 96 }} />
                                                                <col style={{ width: 90 }} />
                                                                <col style={{ width: 100 }} />
                                                                {showLineTax && <col style={{ width: 50 }} />}
                                                            </colgroup>

                                                            {/* Table Head */}
                                                            <TableHead
                                                                sx={{
                                                                    backgroundColor: '#F8F8F8',
                                                                    height: '40px',
                                                                    borderBottom: 'none',
                                                                }}
                                                            >
                                                                <TableRow
                                                                    sx={{
                                                                        height: '40px',
                                                                        borderBottom: 'none',
                                                                        '& > th, & > td': {
                                                                            px: '12px',
                                                                        },
                                                                    }}
                                                                >
                                                                    {/* NO */}
                                                                    <TableCell
                                                                        sx={{
                                                                            width: '56px',
                                                                            fontSize: '14px',
                                                                            borderBottom: 'none',
                                                                        }}
                                                                        style={{
                                                                            padding: '6px 0 6px 16px',
                                                                        }}
                                                                    >
                                                                        No.
                                                                    </TableCell>

                                                                    {/* DESCRIPTION */}
                                                                    <TableCell
                                                                        sx={{
                                                                            fontSize: '14px',
                                                                            borderBottom: 'none',
                                                                        }}
                                                                        style={{
                                                                            height: '40px',
                                                                            padding: '6px 10px 6px 0',
                                                                        }}
                                                                    >
                                                                        Description
                                                                    </TableCell>

                                                                    {/* QUANTITY */}
                                                                    <TableCell
                                                                        sx={{
                                                                            width: '96px',
                                                                            fontSize: '14px',
                                                                            borderBottom: 'none',
                                                                        }}
                                                                        style={{ padding: '0 10px' }}
                                                                    >
                                                                        Quantity
                                                                    </TableCell>

                                                                    {/* PRICE */}
                                                                    <TableCell
                                                                        sx={{
                                                                            width: '90px',
                                                                            fontSize: '14px',
                                                                            borderBottom: 'none',
                                                                        }}
                                                                        style={{ padding: '0 10px' }}
                                                                    >
                                                                        Price
                                                                    </TableCell>

                                                                    {/* AMOUNT */}
                                                                    <TableCell
                                                                        align={showLineTax ? 'left' : 'right'}
                                                                        sx={{
                                                                            width: '100px',
                                                                            fontSize: '14px',
                                                                            borderBottom: 'none',
                                                                        }}
                                                                        style={{ padding: '0 10px' }}
                                                                    >
                                                                        Amount
                                                                    </TableCell>

                                                                    {/* TAX */}
                                                                    {showLineTax && (
                                                                        <TableCell
                                                                            align="center"
                                                                            sx={{
                                                                                width: '52px',
                                                                                fontSize: '14px',
                                                                                paddingTop: '0',
                                                                                paddingBottom: '0',
                                                                                borderBottom: 'none',
                                                                            }}
                                                                            style={{ paddingRight: '16px', paddingLeft: '10px' }}
                                                                        >
                                                                            Tax
                                                                        </TableCell>
                                                                    )}
                                                                </TableRow>
                                                            </TableHead>

                                                            <TableBody>
                                                                {/* DESCRIPTION ROW */}
                                                                {item?.description?.trim() && (
                                                                    <TableRow key={item?.labor?.qty}>
                                                                        <TableCell
                                                                            style={{
                                                                                padding: '6px 0 6px 16px',
                                                                            }}
                                                                        />

                                                                        <TableCell
                                                                            style={{
                                                                                padding: '6px 10px 6px 0',
                                                                            }}
                                                                        >
                                                                            <Typography
                                                                                variant="body2"
                                                                                sx={{
                                                                                    fontSize: '16px',
                                                                                    fontWeight: 400,
                                                                                    lineHeight: '143%',
                                                                                    color: '#212121',
                                                                                }}
                                                                            >
                                                                                {item?.description}
                                                                            </Typography>
                                                                        </TableCell>

                                                                        <TableCell style={{ padding: '6px 10px' }} />
                                                                        <TableCell style={{ padding: '6px 10px' }} />
                                                                        <TableCell style={{ padding: '6px 10px' }} />
                                                                        {showLineTax && <TableCell style={{ padding: '6px 16px 6px 10px' }} />}
                                                                    </TableRow>
                                                                )}

                                                                {/* LABOUR ROW */}
                                                                {item?.labor && item?.labor?.qty > 0 && (
                                                                    <TableRow key={item.no}>
                                                                        <TableCell
                                                                            style={{
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                                padding: '6px 0 6px 16px',
                                                                            }}
                                                                        >
                                                                            1
                                                                        </TableCell>

                                                                        <TableCell
                                                                            style={{
                                                                                padding: '6px 10px 6px 0',
                                                                            }}
                                                                        >
                                                                            <Typography
                                                                                sx={{
                                                                                    fontSize: '16px',
                                                                                    fontWeight: 400,
                                                                                    lineHeight: '143%',
                                                                                }}
                                                                            >
                                                                                Labour
                                                                            </Typography>
                                                                        </TableCell>

                                                                        {/* QUANTITY */}
                                                                        <TableCell
                                                                            style={{
                                                                                padding: '6px 10px',
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                            }}
                                                                        >
                                                                            {item?.labor?.qty}
                                                                        </TableCell>

                                                                        {/* PRICE */}
                                                                        <TableCell
                                                                            style={{
                                                                                padding: '6px 10px',
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                            }}
                                                                        >
                                                                            {item?.labor?.ratePerHour
                                                                                ? NumericEngine.format(item?.labor?.ratePerHour || 0, {
                                                                                      formatCurrency: true,
                                                                                      trailingZeros: true,
                                                                                  })
                                                                                : '$0.00'}
                                                                        </TableCell>

                                                                        {/* AMOUNT */}
                                                                        <TableCell
                                                                            align={showLineTax ? 'left' : 'right'}
                                                                            style={{
                                                                                padding: '6px 10px',
                                                                                fontSize: '16px',
                                                                            }}
                                                                        >
                                                                            <Typography fontWeight={400} fontSize={16}>
                                                                                {item?.labor?.totalAmount
                                                                                    ? NumericEngine.format(item?.labor?.totalAmount || 0, {
                                                                                          formatCurrency: true,
                                                                                          trailingZeros: true,
                                                                                      })
                                                                                    : '$0.00'}
                                                                            </Typography>
                                                                        </TableCell>

                                                                        {/* TAX */}
                                                                        {showLineTax && (
                                                                            <TableCell
                                                                                align="center"
                                                                                style={{
                                                                                    padding: '6px 16px 6px 8px',
                                                                                    fontSize: '16px',
                                                                                }}
                                                                            >
                                                                                <LineTaxCell
                                                                                    taxesBreakdown={item?.labor?.taxesBreakdown}
                                                                                    lineAmount={item?.labor?.totalAmount}
                                                                                    documentType={DOCUMENT_TAX_TYPE.ESTIMATE}
                                                                                    shopTaxesData={shopTaxesData}
                                                                                    provinceTaxGroup={provinceTaxGroup}
                                                                                    documentHasPartsOrPackages={documentHasPartsOrPackages}
                                                                                    kind={LINE_TAX_KIND.LABOUR}
                                                                                    editable={false}
                                                                                    discount={estimateData?.discount}
                                                                                    subTotal={estimateData?.subTotal}
                                                                                />
                                                                            </TableCell>
                                                                        )}
                                                                    </TableRow>
                                                                )}

                                                                {item?.parts &&
                                                                    item?.parts?.length > 0 &&
                                                                    item?.parts.map((row, index) => {
                                                                        // A managed part's per-unit fee is billed on its own row, exactly as on an invoice.
                                                                        const showFeeCell = row?.fee?.name && row.feeAmount > 0;
                                                                        return (
                                                                            <Fragment key={row?._id || index}>
                                                                                <TableRow>
                                                                                    {/* NO */}
                                                                                    <TableCell
                                                                                        style={{
                                                                                            padding: '6px 0 6px 16px',
                                                                                            fontSize: '16px',
                                                                                            fontWeight: 400,
                                                                                            borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                        }}
                                                                                    >
                                                                                        {index + (item?.fixedPrice > 0 || item?.labor?.qty > 0 ? 2 : 1)}
                                                                                    </TableCell>

                                                                                    {/* DESCRIPTION */}
                                                                                    <TableCell
                                                                                        style={{
                                                                                            padding: '6px 10px 6px 0',
                                                                                            borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                        }}
                                                                                    >
                                                                                        <Box>
                                                                                            {/* Managed parts open their inventory record, exactly as on an invoice. */}
                                                                                            <Typography
                                                                                                sx={{
                                                                                                    color: 'rgba(0, 0, 0, 0.87)',
                                                                                                    fontSize: '16px',
                                                                                                    fontWeight: 400,
                                                                                                    letterSpacing: '0.17px',
                                                                                                    lineHeight: '143%',
                                                                                                    textDecoration:
                                                                                                        row.inventoryType === INVENTORY_MANAGE_TYPE.UNMANAGED
                                                                                                            ? 'none'
                                                                                                            : 'underline',
                                                                                                    cursor:
                                                                                                        row.inventoryType === INVENTORY_MANAGE_TYPE.UNMANAGED
                                                                                                            ? 'default'
                                                                                                            : 'pointer',
                                                                                                }}
                                                                                                onClick={() => {
                                                                                                    if (row.inventoryType === INVENTORY_MANAGE_TYPE.UNMANAGED) {
                                                                                                        return;
                                                                                                    }
                                                                                                    setSelectedInventoryId(
                                                                                                        row?.inventoryId || row?.inventory?._id
                                                                                                    );
                                                                                                    setInventoryOption(row);
                                                                                                    if (row?.inventoryBatches?.length > 1) {
                                                                                                        setBatchSelectionModal(true);
                                                                                                    } else if (
                                                                                                        row?.inventoryBatches?.length > 0 &&
                                                                                                        row?.inventoryBatches[0]?.batchNumber
                                                                                                    ) {
                                                                                                        setBatchNumber(
                                                                                                            row?.inventoryBatches[0]?.batchNumber ||
                                                                                                                row.batchNumber[0]
                                                                                                        );
                                                                                                        setOpenpartModel(true);
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                                {row?.partName || row?.inventory?.part?.partName}
                                                                                            </Typography>

                                                                                            <Stack
                                                                                                direction="row"
                                                                                                spacing={1.25}
                                                                                                divider={
                                                                                                    <Box
                                                                                                        sx={{
                                                                                                            width: '1px',
                                                                                                            height: '16px',
                                                                                                            bgcolor: 'rgba(0, 0, 0, 0.12)',
                                                                                                        }}
                                                                                                    />
                                                                                                }
                                                                                            >
                                                                                                {(row?.partNumber || row?.tyreDimension) && (
                                                                                                    <Stack
                                                                                                        direction="row"
                                                                                                        alignItems="center"
                                                                                                        spacing={0.5}
                                                                                                        mt={'4px'}
                                                                                                    >
                                                                                                        <Typography
                                                                                                            component="span"
                                                                                                            sx={{
                                                                                                                fontSize: '16px',
                                                                                                                fontWeight: 400,
                                                                                                                letterSpacing: '0.17px',
                                                                                                                color: '#006CDD',
                                                                                                            }}
                                                                                                        >
                                                                                                            #
                                                                                                        </Typography>
                                                                                                        <Typography
                                                                                                            component="span"
                                                                                                            sx={{
                                                                                                                fontSize: '16px',
                                                                                                                fontWeight: 400,
                                                                                                                letterSpacing: '0.17px',
                                                                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                                                            }}
                                                                                                        >
                                                                                                            {/* partsType is not always returned; fall back to whichever identifier the part carries. */}
                                                                                                            {(row?.part?.partsType ?? row?.partsType) ===
                                                                                                            PART_TYPES.TYRE
                                                                                                                ? row?.tyreDimension || row?.partNumber
                                                                                                                : row?.partNumber || row?.tyreDimension}
                                                                                                        </Typography>
                                                                                                    </Stack>
                                                                                                )}

                                                                                                {row?.supplier?.name && (
                                                                                                    <Stack direction="row" alignItems="center" spacing={0.75}>
                                                                                                        <PartBrandSvg />
                                                                                                        <Typography
                                                                                                            sx={{
                                                                                                                fontSize: '16px',
                                                                                                                fontWeight: 400,
                                                                                                                letterSpacing: '0.17px',
                                                                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                                                            }}
                                                                                                        >
                                                                                                            {row.supplier.name}
                                                                                                        </Typography>
                                                                                                    </Stack>
                                                                                                )}

                                                                                                {row?.partsBrand?.name && (
                                                                                                    <Stack direction="row" alignItems="center" spacing={0.75}>
                                                                                                        <PartCategorySvg />
                                                                                                        <Typography
                                                                                                            sx={{
                                                                                                                fontSize: '16px',
                                                                                                                fontWeight: 400,
                                                                                                                letterSpacing: '0.17px',
                                                                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                                                            }}
                                                                                                        >
                                                                                                            {row.partsBrand.name}
                                                                                                        </Typography>
                                                                                                    </Stack>
                                                                                                )}
                                                                                            </Stack>
                                                                                        </Box>
                                                                                    </TableCell>

                                                                                    {/* QUANTITY */}
                                                                                    <TableCell
                                                                                        style={{
                                                                                            padding: '6px 10px',
                                                                                            fontSize: '16px',
                                                                                            fontWeight: 400,
                                                                                            borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                        }}
                                                                                    >
                                                                                        {row?.totalQty ?? row?.qty}
                                                                                    </TableCell>

                                                                                    {/* PRICE */}
                                                                                    <TableCell
                                                                                        style={{
                                                                                            padding: '6px 10px',
                                                                                            fontSize: '16px',
                                                                                            fontWeight: 400,
                                                                                            borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                        }}
                                                                                    >
                                                                                        {row?.cost
                                                                                            ? NumericEngine.format(row?.cost || 0, {
                                                                                                  formatCurrency: true,
                                                                                                  trailingZeros: true,
                                                                                              })
                                                                                            : '$0.00'}
                                                                                    </TableCell>

                                                                                    {/* AMOUNT */}
                                                                                    <TableCell
                                                                                        align={showLineTax ? 'left' : 'right'}
                                                                                        style={{
                                                                                            padding: '6px 10px',
                                                                                            fontSize: '16px',
                                                                                            borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                        }}
                                                                                    >
                                                                                        <Typography fontWeight={400} fontSize={16}>
                                                                                            {row?.totalAmount
                                                                                                ? NumericEngine.format(row?.totalAmount || 0, {
                                                                                                      formatCurrency: true,
                                                                                                      trailingZeros: true,
                                                                                                  })
                                                                                                : '$0.00'}
                                                                                        </Typography>
                                                                                    </TableCell>

                                                                                    {/* TAX */}
                                                                                    {showLineTax && (
                                                                                        <TableCell
                                                                                            align="center"
                                                                                            style={{
                                                                                                padding: '6px 16px 6px 10px',
                                                                                                fontSize: '16px',
                                                                                                borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                            }}
                                                                                        >
                                                                                            <LineTaxCell
                                                                                                taxesBreakdown={row?.taxesBreakdown}
                                                                                                lineAmount={recordPartGrossAmount(row)}
                                                                                                documentType={DOCUMENT_TAX_TYPE.ESTIMATE}
                                                                                                shopTaxesData={shopTaxesData}
                                                                                                provinceTaxGroup={provinceTaxGroup}
                                                                                                documentHasPartsOrPackages={documentHasPartsOrPackages}
                                                                                                kind={LINE_TAX_KIND.PARTS}
                                                                                                editable={false}
                                                                                                discount={estimateData?.discount}
                                                                                                subTotal={estimateData?.subTotal}
                                                                                            />
                                                                                        </TableCell>
                                                                                    )}
                                                                                </TableRow>

                                                                                {row?.lastDescription && (
                                                                                    <TableRow>
                                                                                        <TableCell
                                                                                            style={{
                                                                                                padding: '0 12px 6px 16px',
                                                                                                borderBottom: showFeeCell ? 'none' : undefined,
                                                                                            }}
                                                                                        />
                                                                                        <TableCell
                                                                                            colSpan={3}
                                                                                            style={{
                                                                                                padding: '0 12px 6px 0',
                                                                                                borderBottom: showFeeCell ? 'none' : undefined,
                                                                                            }}
                                                                                        >
                                                                                            <Typography
                                                                                                sx={{
                                                                                                    fontSize: '14px',
                                                                                                    fontWeight: 400,
                                                                                                    lineHeight: '20px',
                                                                                                    letterSpacing: '0.4px',
                                                                                                    color: '#848484',
                                                                                                }}
                                                                                            >
                                                                                                {row?.lastDescription}
                                                                                            </Typography>
                                                                                        </TableCell>
                                                                                        {showLineTax && (
                                                                                            <TableCell
                                                                                                style={{
                                                                                                    paddingTop: 0,
                                                                                                    borderBottom: showFeeCell ? 'none' : undefined,
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </TableRow>
                                                                                )}

                                                                                {showFeeCell && (
                                                                                    <TableRow>
                                                                                        <TableCell style={{ padding: '0 12px 6px 16px', fontSize: '16px' }} />
                                                                                        <TableCell style={{ padding: '0 12px 6px 0', fontSize: '16px' }}>
                                                                                            {row?.fee?.name}
                                                                                        </TableCell>
                                                                                        <TableCell style={{ padding: '0 12px', fontSize: '16px' }}>
                                                                                            {row?.totalQty ?? row?.qty}
                                                                                        </TableCell>
                                                                                        <TableCell style={{ padding: '0 12px', fontSize: '16px' }}>
                                                                                            {NumericEngine.format(row?.feeAmount || 0, {
                                                                                                formatCurrency: true,
                                                                                                trailingZeros: true,
                                                                                            })}
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            align={showLineTax ? 'left' : 'right'}
                                                                                            style={{ padding: '0 12px', fontSize: '16px' }}
                                                                                        >
                                                                                            {NumericEngine.format(
                                                                                                NumericEngine.multiply(
                                                                                                    row?.totalQty ?? row?.qty ?? 0,
                                                                                                    row?.feeAmount || 0
                                                                                                ),
                                                                                                {
                                                                                                    formatCurrency: true,
                                                                                                    trailingZeros: true,
                                                                                                }
                                                                                            )}
                                                                                        </TableCell>
                                                                                        {showLineTax && (
                                                                                            <TableCell style={{ padding: '0 16px 0 10px', fontSize: '16px' }} />
                                                                                        )}
                                                                                    </TableRow>
                                                                                )}
                                                                            </Fragment>
                                                                        );
                                                                    })}

                                                                {shouldShowPerServiceSubtotalRow(item, { variant: 'estimate-detail' }) && (
                                                                    <TableRow>
                                                                        <TableCell
                                                                            colSpan={4}
                                                                            style={{
                                                                                // borderBottom: 0,
                                                                                background: '#fff',
                                                                                padding: '12px',
                                                                            }}
                                                                        />

                                                                        {/* TOTAL AMOUNT */}
                                                                        <TableCell
                                                                            align={showLineTax ? 'left' : 'right'}
                                                                            style={{
                                                                                // borderBottom: 0,
                                                                                background: '#fff',
                                                                                padding: '6px 10px',
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                            }}
                                                                        >
                                                                            <Typography fontWeight={400} fontSize={16}>
                                                                                {serviceSubtotal > 0
                                                                                    ? NumericEngine.format(serviceSubtotal, {
                                                                                          formatCurrency: true,
                                                                                          trailingZeros: true,
                                                                                      })
                                                                                    : '$0.00'}
                                                                            </Typography>
                                                                        </TableCell>

                                                                        {showLineTax && (
                                                                            <TableCell
                                                                                style={{
                                                                                    // borderBottom: 0,
                                                                                    background: '#fff',
                                                                                    padding: '12px',
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        ) : (
                                            <>
                                                <Grid container item>
                                                    <Grid item xs={12}>
                                                        <TableContainer sx={{ maxHeight: 600 }}>
                                                            <Table
                                                                aria-label="fixed price table"
                                                                padding="16px"
                                                                sx={{
                                                                    width: '100%',
                                                                    tableLayout: 'fixed',

                                                                    '& .MuiTableCell-root': {
                                                                        borderBottom: '1px solid rgba(0,0,0,0.12)',
                                                                        verticalAlign: 'middle',
                                                                        color: '#212121',
                                                                    },
                                                                }}
                                                            >
                                                                <colgroup>
                                                                    <col style={{ width: 56 }} />
                                                                    <col />
                                                                    <col style={{ width: 96 }} />
                                                                    <col style={{ width: 90 }} />
                                                                    <col style={{ width: 100 }} />
                                                                    {showLineTax && <col style={{ width: 52 }} />}
                                                                </colgroup>

                                                                {/* TABLE HEAD */}
                                                                <TableHead
                                                                    sx={{
                                                                        backgroundColor: '#F8F8F8',
                                                                        height: '40px',
                                                                        borderBottom: 'none',
                                                                    }}
                                                                >
                                                                    <TableRow
                                                                        sx={{
                                                                            height: '40px',
                                                                            borderBottom: 'none',
                                                                            '& > th, & > td': {
                                                                                px: '12px',
                                                                            },
                                                                        }}
                                                                    >
                                                                        <TableCell
                                                                            sx={{
                                                                                width: '56px',
                                                                                fontSize: '14px',
                                                                                borderBottom: 'none',
                                                                            }}
                                                                            style={{
                                                                                padding: '6px 0 6px 16px',
                                                                            }}
                                                                        >
                                                                            No.
                                                                        </TableCell>

                                                                        <TableCell
                                                                            sx={{
                                                                                fontSize: '14px',
                                                                                borderBottom: 'none',
                                                                            }}
                                                                            style={{
                                                                                height: '40px',
                                                                                padding: '6px 10px 6px 0px',
                                                                            }}
                                                                        >
                                                                            Description
                                                                        </TableCell>

                                                                        <TableCell
                                                                            sx={{
                                                                                width: '96px',
                                                                                fontSize: '14px',
                                                                                borderBottom: 'none',
                                                                            }}
                                                                            style={{ padding: '0 10px' }}
                                                                        >
                                                                            Quantity
                                                                        </TableCell>

                                                                        <TableCell
                                                                            sx={{
                                                                                width: '96px',
                                                                                fontSize: '14px',
                                                                                borderBottom: 'none',
                                                                            }}
                                                                            style={{ padding: '0 10px' }}
                                                                        >
                                                                            Price
                                                                        </TableCell>

                                                                        <TableCell
                                                                            align={showLineTax ? 'left' : 'right'}
                                                                            sx={{
                                                                                width: '100px',
                                                                                fontSize: '14px',
                                                                                borderBottom: 'none',
                                                                            }}
                                                                            style={{ padding: '0 10px' }}
                                                                        >
                                                                            Amount
                                                                        </TableCell>

                                                                        {/* TAX */}
                                                                        {showLineTax && (
                                                                            <TableCell
                                                                                align="center"
                                                                                sx={{
                                                                                    width: '52px',
                                                                                    fontSize: '14px',
                                                                                    paddingTop: '0',
                                                                                    paddingBottom: '0',
                                                                                    borderBottom: 'none',
                                                                                }}
                                                                                style={{ paddingRight: '16px' }}
                                                                            >
                                                                                Tax
                                                                            </TableCell>
                                                                        )}
                                                                    </TableRow>
                                                                </TableHead>

                                                                {/* TABLE BODY */}
                                                                <TableBody>
                                                                    <TableRow>
                                                                        <TableCell
                                                                            style={{
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                                padding: '6px 0 6px 16px',
                                                                            }}
                                                                        >
                                                                            1
                                                                        </TableCell>

                                                                        <TableCell
                                                                            style={{
                                                                                padding: '6px 10px 6px 0',
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                            }}
                                                                        >
                                                                            {item?.description || 'Fixed Price'}
                                                                        </TableCell>

                                                                        <TableCell style={{ padding: '6px 10px' }} />

                                                                        <TableCell style={{ padding: '6px 10px' }} />

                                                                        {/* AMOUNT */}
                                                                        <TableCell
                                                                            align={showLineTax ? 'left' : 'right'}
                                                                            style={{
                                                                                padding: '6px 10px',
                                                                                fontSize: '16px',
                                                                            }}
                                                                        >
                                                                            <Typography fontWeight={400} fontSize={16}>
                                                                                {item?.fixedPrice
                                                                                    ? NumericEngine.format(item?.fixedPrice || 0, {
                                                                                          formatCurrency: true,
                                                                                          trailingZeros: true,
                                                                                      })
                                                                                    : '$0.00'}
                                                                            </Typography>
                                                                        </TableCell>

                                                                        {/* TAX */}
                                                                        {showLineTax && (
                                                                            <TableCell
                                                                                align="center"
                                                                                style={{
                                                                                    padding: '6px 16px 6px 10px',
                                                                                    fontSize: '16px',
                                                                                }}
                                                                            >
                                                                                <LineTaxCell
                                                                                    taxesBreakdown={item?.taxesBreakdown}
                                                                                    lineAmount={item?.fixedPrice}
                                                                                    documentType={DOCUMENT_TAX_TYPE.ESTIMATE}
                                                                                    shopTaxesData={shopTaxesData}
                                                                                    provinceTaxGroup={provinceTaxGroup}
                                                                                    documentHasPartsOrPackages={documentHasPartsOrPackages}
                                                                                    kind={LINE_TAX_KIND.PACKAGE}
                                                                                    editable={false}
                                                                                    discount={estimateData?.discount}
                                                                                    subTotal={estimateData?.subTotal}
                                                                                />
                                                                            </TableCell>
                                                                        )}
                                                                    </TableRow>
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        )}
                                    </>
                                );
                            })}
                        {/* Fees Table  */}
                        {estimateData?.fees?.length > 0 && <EstimateFeesTable estimateData={estimateData} />}

                        {estimateData?.recommendationNotes && <InvoiceRecommandationSection invoiceData={estimateData} />}

                        <Grid container spacing={2} mt={'32px'} justifyContent={'space-between'} alignItems={'flex-start'}>
                            <Grid item xs={12} md={6} lg={6} xl={7}>
                                {estimateData?.termsAndWarranty?.title && estimateData?.termsAndWarranty?.description && (
                                    <EstimateTermsAndWarranty estimateData={estimateData} />
                                )}
                            </Grid>
                            <Grid item xs={12} md={6} lg={6} xl={5}>
                                {/* Payment Details Table  */}
                                <EstimatePaymentDetails estimateData={estimateData} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            {openEditCustomer && (
                <Suspense fallback={<CircularProgress />}>
                    <AddCustomerModalV4
                        from="invoice_email"
                        openModal={openEditCustomer}
                        customerId={estimateData?.customer?.refIdImport || estimateData?.customer?.refIdUsers || customerId}
                        customerType={estimateData?.customer?.createdFrom || estimateData?.customer?.source || SHOP_CREATED}
                        onClose={() => {
                            setOpenEditCustomer(false);
                        }}
                        onSubmitModal={(updatedCustomer) => {
                            setOpenEditCustomer(false);

                            // update local customer state if needed
                            if (updatedCustomer) {
                                setCustomerData?.(updatedCustomer);
                            }

                            // continue send flow
                            handleSend();
                        }}
                    />
                </Suspense>
            )}
            <CommonDialog
                loader={deleteLoader}
                open={isDeleteModal}
                onClose={() => {
                    setIsDeleteModal(false);
                }}
                onSave={async () => {
                    setDeleteLoader(true);
                    const resp = await deleteFinalizedEstimate(estimateId);
                    if (resp) {
                        queryClient.invalidateQueries({ queryKey: estimateQueryKeys.all, refetchType: 'all' });
                        navigate('/estimates/all');
                    }
                    setIsDeleteModal(false);
                    setDeleteLoader(true);
                }}
                dialogTitle={'Delete Estimate?'}
                dialogSubtitle={`Are you sure you want to delete Estimate ${estimateData?.estimateNumber || ''}? This action cannot be undone.`}
            />

            {/* Read-only inventory record for a managed part — same modal as the invoice detail page. */}
            <AddInventoryModal
                type={INVENTORY_TYPES.INVOICE}
                showUsedInInvoiceFeild={true}
                FeildLabelName="Used in Estimate"
                isUsedInvoiceQty={inventoryOption?.totalQty}
                isUseLastCost={inventoryOption?.totalQty ? true : false}
                inventoryId={selectedInventoryId}
                batchNumber={batchNumber}
                viewOnly={true}
                openModal={openPartModel}
                closeModal={() => {
                    setOpenpartModel(false);
                    setInventoryOption(null);
                    setSelectedInventoryId(null);
                    setBatchNumber(null);
                }}
                onSubmitModal={() => {
                    setOpenpartModel(false);
                    setSelectedInventoryId(null);
                    setInventoryOption(null);
                    setBatchNumber(null);
                }}
                showLoader={false}
                setShowLoader={() => {}}
                selectedInventory={[]}
                setSelectedInventory={() => {}}
                fetchApi={() => {}}
                ShowAllTabs={false}
                ShowTabIndex={0}
                modalType={'edit'}
            />

            <SuccessMessageModal message={successMessage} open={openSuccessModal} setOpenSuccessModal={setOpenSuccessModal} />
            <Dialog open={showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default EstimateFinalized;
